(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lh-header"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',function(e){const b=e.target.closest('.lh-menu-btn');if(!b)return;const h=b.closest('[data-lh-header]'),n=h.querySelector('.lh-mobile-nav'),o=b.getAttribute('aria-expanded')==='true';b.setAttribute('aria-expanded',String(!o));n.hidden=o;});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
